export { default } from "./Page";



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-client/pages/Page/index.js